import React from 'react';
import styled from 'styled-components';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const Button = styled.button `
    ${props =>  `
        width: 50px !important;
        height: 50px !important;
        position: relative;
        cursor: pointer;
        border: none;   
        font-family: 'zx_spectrum7_boldregular', sans;
        color: #ffffff;
        font-size: 3em;
        line-height: 0em;
        border: 2px solid white;
        padding: 0;

        img {
            width: 100%;
            height: auto;
        }
    `}
`;

const styles = (props) => ({
    root: {}, 
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    character: stores.characters.character,
    characters: stores.characters.characters,
    setCharacter: (character) => stores.characters.setCharacter(character),
})

class CharactersButtons extends React.Component {
    render() {
        const { characters = [] } = this.props;
        return (
            <React.Fragment>
                {[...this._generateButtons(characters)]}
            </React.Fragment>
        )
    }

    *_generateButtons(content) {
        content = content || [];
        content = content.entries();

        for(const [i, entry] of content) {
            yield this._renderButton(`characters-${i}`, entry);
        }
    }

    _renderButton(key, content) {
        const { setCharacter, character, intl } = this.props;
        // Keep references to named entries
        let ref = this.refs[key];
        if (!ref) {
            ref = React.createRef();
            this.refs = Object.assign({}, this.refs, { [key]: ref });
        }

        let { thumb } = content;

        const activated = character.id === content.id;

        if (!activated) thumb = thumb.replace('.png', '-pb.png');     
        
        return (
            <Button
                key={key}
                re={ref}
                className={
                    classNames({
                    activated 
                })}
                title={intl[content.aria.title]}
                aria-label={intl[content.aria.title]}
                style={{ backgroundColor: !activated ? 'gray' : content.color }}
                onClick={() => setCharacter(content.id)}
                {...content}>
                <img 
                    src={thumb}
                    alt={intl[content.aria.button]}
                    title={intl[content.aria.button]} />
            </Button>
        );
    }
}

export default inject(mapper)(
    withStyles(styles)(CharactersButtons)
);